import { ApiClient } from "./client";
import { GO2NFT_API_URL } from "src/config";

export const apiClient = new ApiClient({ baseUrl: GO2NFT_API_URL });
